import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export function useEmitZapCreateEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(() => {
    emitUserInteractionEvent({
      accountId,
      eventAction: "click",
      interactionName: UserInteractionName.ZapCreate,
      optionSelected: "not_applicable",
      systemName: SERVICE_NAME,
    });
  }, [accountId]);

  return emit;
}
